import React, { useEffect, useRef, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AssignmentIcon from '@mui/icons-material/Assignment';
import GroupIcon from '@mui/icons-material/Group';

const NavLinksSection = ({ clickedItem, handleClick }) => {
  const navRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const nav = navRef.current;
      const topOffset = nav?.getBoundingClientRect().top || 0;
      setIsSticky(topOffset <= 0);

      const middle = window.innerHeight / 2;
      const sections = ['what_we_do', 'our_vision', 'our_mission', 'our_team'];

      sections.forEach((sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= middle && rect.bottom >= middle) {
            if (typeof handleClick === 'function') {
              handleClick(sectionId);
            }
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleClick]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -90;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const navItems = [
    { text: 'What We Do?', id: 'what_we_do', icon: <EmojiObjectsIcon fontSize="small" /> },
    { text: 'Our Vision', id: 'our_vision', icon: <VisibilityIcon fontSize="small" /> },
    { text: 'Our Mission', id: 'our_mission', icon: <AssignmentIcon fontSize="small" /> },
    { text: 'Our Team', id: 'our_team', icon: <GroupIcon fontSize="small" /> },
  ];

  return (
    <Box
      ref={navRef}
      sx={{
        // border: "1px solid red",
        position: 'sticky',
        top: 0,
        zIndex: 10,
        display: { xs: 'none', sm: 'none', md: 'flex' },
        justifyContent: 'center',
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        boxShadow: isSticky ? '0 2px 10px rgba(0,0,0,0.1)' : 'none',
        transition: 'all 0.3s ease-in-out',
        py: isSticky ? 2.5 : 2.5,
        marginLeft: 2
      }}
    >
      <Box
        sx={{
          // border: "1px solid red",
          width: { xl: '72%', lg: '80%', md: '90%' },
          px: 8,
          display: 'flex',
          alignItems: 'center',
          
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={isSticky ? 8 : 6} // Increased gap when sticky
        >
          {navItems.map((item, index) => (
            <Typography
              key={index}
              onClick={() => {
                if (typeof handleClick === 'function') handleClick(item.id);
                scrollToSection(item.id);
              }}
              tabIndex={0}
              role="button"
              aria-label={`Scroll to ${item.text} section`}
              aria-current={clickedItem === item.id ? 'page' : undefined}
              sx={{
                // border: "1px solid red",
                display: 'flex',
                alignItems: 'center',
                gap: isSticky ? 0 : 1.2,
                // color: clickedItem === item.id ? '#054E91' : 'rgba(0,0,0,0.3)',
                color: clickedItem === item.id ? '#054E91' : isSticky ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0.2)',
                fontFamily: "'Roboto', sans-serif",
                fontWeight: 500,
                fontSize: { md: '17px', lg: '18px' },
                cursor: 'pointer',
                px: 1.5,
                letterSpacing: '0.7px',
                position: 'relative',
                transition: 'color 0.3s ease, padding 0.3s ease',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -6,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  height: '2px',
                  width: clickedItem === item.id ? '100%' : '0%',
                  backgroundColor: '#054E91',
                  transition: 'width 0.3s ease-in-out',
                  borderRadius: '1px',
                },
                '&:hover': {
                  color: '#054E91',
                  '&::after': {
                    width: '100%',
                  },
                },
              }}
            >
              {!isSticky && item.icon}
              <span style={{ marginLeft: !isSticky ? 6 : 0 }}>{item.text}</span>
            </Typography>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default NavLinksSection;
